import {
  faBadgeCheck,
  faCalendar,
  faChartKanban,
  faCreditCard,
  faDesktop,
  faFire,
  faMessage,
  faPiggyBank,
  faRightFromBracket,
  faStar,
  faUserGroup,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import * as ROUTES from '../../../constants';

export const DROPDOWN_MENU_CONTENT_CLASSES = [
  'min-w-56',
  'rounded-lg',
  'w-(--radix-dropdown-menu-trigger-width)',
].join(' ');

export const NAV_LINKS = [
  {
    icon: faChartKanban,
    label: 'Workflow',
    path: ROUTES.WORKFLOW,
  },
  {
    icon: faCalendar,
    label: 'Calendar',
    path: ROUTES.CALENDAR,
  },
  {
    icon: faMessage,
    label: 'Messenger',
    path: ROUTES.MESSENGER,
  },
  {
    icon: faPiggyBank,
    label: 'Payments',
    nestedLinks: [
      {
        label: 'Payments',
        path: ROUTES.PAYMENTS,
      },
      {
        label: 'Payouts',
        path: ROUTES.PAYOUTS,
      },
      {
        label: 'Onboarding',
        path: ROUTES.PAYMENTS_ONBOARDING,
      },
    ],
  },
  {
    icon: faDesktop,
    label: 'Website',
    path: ROUTES.WEBSITE,
  },
  {
    icon: faUserGroup,
    label: 'People',
    path: ROUTES.PEOPLE,
  },
  {
    icon: faStar,
    label: 'Reviews',
    nestedLinks: [
      {
        label: 'Reviews',
        path: ROUTES.REVIEWS,
      },
      {
        label: 'Settings',
        path: ROUTES.REVIEW_SETTINGS,
      },
    ],
  },
];

export const SIDEBAR_MENU_BUTTON_CLASSES = [
  'data-[state=open]:bg-sidebar-accent',
  'data-[state=open]:text-sidebar-accent-foreground',
].join(' ');

export const USER_SELECT_LINKS = [
  {
    groupName: 'primary',
    links: [
      {
        label: 'Account',
        icon: faBadgeCheck,
      },
      {
        label: 'Billing',
        icon: faCreditCard,
        path: ROUTES.BILLING,
      },
    ],
  },
  {
    groupName: 'secondary',
    links: [
      {
        action: 'logout',
        label: 'Log out',
        icon: faRightFromBracket,
      },
    ],
  },
];

export const WORKSPACES = [
  {
    name: 'Haycock-Cavanagh Funeral Home',
    logo: faFire,
    phone: '(519) 627-8726',
  },
  {
    name: 'Nicholls Funeral Home',
    logo: faFire,
    phone: '(519) 365-1015',
  },
];
